module.exports = __webpack_public_path__ + "img/bg1.ec28ca11.svg";